<script>
    import { createEventDispatcher } from "svelte";
    import { Accordion, AccordionItem, Button, ButtonGroup } from "@sveltestrap/sveltestrap";

    export let seasonsBest;
    export let stats;
    export let joueurs;
    export let seasons;
    let season = seasons[seasons.length - 1];
    let top50NofMatchs = [];
    let top50PctWins = [];
    let minMatchsForPct = 12;
    let topValue = 100;

    let statsgenRows = [
        "Total",
        "Libre",
        "1 Bande",
        "3 Bandes",
        "4 billes",
        "Cadre 42/2",
        "Cadre 47/2",
        "Cadre 71/2",
        "Cadre 47/1",
        "Indiv",
        "Indiv Loisir",
        "Equipe",
        "Equipe Loisir",
    ];
    let statsLibreRows = ["Masters", "N1", "N3", "R1", "R2", "R3", "R4"];
    let statsBandeRows = ["Masters", "N1", "N3", "R1", "R2"];
    let stats3BandesRows = ["Masters", "N1", "N2", "N3", "R1", "R2"];
    let statsCadre472Rows = ["Masters", "N1", "N2"];
    let statsCadre422Rows = ["N3", "R1"];

    const dispatch = createEventDispatcher();

    let dimens = "col-lg-5 col-xl-4 col-xxl-4 col-sm-10 col-md-11 col-12";

    function clickTop(l) {
        dispatch("clickTop", {
            l,
        });
    }

    function TOPperformers(s, thresholdMatchs, topN) {
        top50NofMatchs = seasonsBest[s]
            // .filter((a) => {
            //     return a[1] >= thresholdMatchs;
            // })
            .sort(function (a, b) {
                return b[1] - a[1];
            })
            .slice(0, topN);
        top50PctWins = seasonsBest[s]
            .filter((a) => {
                return a[1] >= thresholdMatchs;
            })
            .sort(function (a, b) {
                return b[3] - a[3];
            })
            .slice(0, topN);

        // console.log(top50PctWins.length)
    }

    function pickSeason(s) {
        season = s.target.value;
        TOPperformers(season, minMatchsForPct, topValue);
    }

    // TOPperformers(season, minMatchsForPct, topValue);
    $: {
        TOPperformers(season, minMatchsForPct, topValue);
    }
</script>

<!-- <h2>I'm here</h2>
<br> -->

<!-- Saison	Tot	Libre	1 Bande	3 Bandes	4 billes	Cadre 42/2	Cadre 47/2	Cadre 71/2	Cadre 47/1	Indiv	Indiv Loisir	Equipe	Equipe Loisir -->
<!-- 0    1     2       3      4             5            6          7           8            9         10         11          12         13          -->
<!-- Libre Masters	Libre N1	Libre N3	Libre R1	Libre R2	Libre R3	Libre R4	1 Bande Masters	1 Bande N1	1 Bande N3	1 Bande R1	1 Bande R2	 -->
<!-- 14            15         16          17         18           19          20           21             22          23          24          25 -->
<!-- 3 Bandes Masters	3 Bandes N1	3 Bandes N2	3 Bandes N3	3 Bandes R1	3 Bandes R2	Cadre 42/2 N3	Cadre 42/2 R1	 -->
<!-- 26            27               28           29       30         31          32                33 -->
<!-- Cadre 47/2 Masters	Cadre 47/2 N1	Cadre 47/2 N2  -->
<!-- 34                35               36 -->
<a
    href="https://app.powerbi.com/view?r=eyJrIjoiN2VhOWI2OTktNTBhNC00NmZmLTg5MGItZTRmZDkxMDJhNzU3IiwidCI6ImU2NjE2ZDk3LTU0MDgtNGY2Ni1iZjkxLTIzOTdkZDczN2MwMSIsImMiOjh9"
    target="_blank"
>
    Tableau de bord FFB Carambole
</a>
<br /><br />
<h4>Matchs joués de {seasons[0]} à {seasons[seasons.length-1]}</h4>
<Accordion>
    <div class={dimens}>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">Par mode de jeu et type</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Statistique</th>
                            {#each seasons as s, i}
                                <th scope="col" class="table-headers">{stats[i][0]}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#each statsgenRows as r, j}
                            <tr>
                                <td class="column-left">{r}</td>

                                {#each seasons as s, i}
                                    <td class="column-right">{stats[i][j + 1]}</td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">Libre par catégorie</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Catégorie</th>
                            {#each seasons as s, i}
                                <th scope="col" class="table-headers">{stats[i][0]}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#each statsLibreRows as r, j}
                            <tr>
                                <td class="column-left">{r}</td>

                                {#each seasons as s, i}
                                    <td class="column-right">{stats[i][j + 14]}</td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">1 Bande par catégorie</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Catégorie</th>
                            {#each seasons as s, i}
                                <th scope="col" class="table-headers">{stats[i][0]}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#each statsBandeRows as r, j}
                            <tr>
                                <td class="column-left">{r}</td>

                                {#each seasons as s, i}
                                    <td class="column-right">{stats[i][j + 21]}</td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">3 Bandes par catégorie</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Catégorie</th>
                            {#each seasons as s, i}
                                <th scope="col" class="table-headers">{stats[i][0]}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#each stats3BandesRows as r, j}
                            <tr>
                                <td class="column-left">{r}</td>

                                {#each seasons as s, i}
                                    <td class="column-right">{stats[i][j + 26]}</td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">Cadre 47/2 par catégorie</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Catégorie</th>
                            {#each seasons as s, i}
                                <th scope="col" class="table-headers">{stats[i][0]}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#each statsCadre472Rows as r, j}
                            <tr>
                                <td class="column-left">{r}</td>

                                {#each seasons as s, i}
                                    <td class="column-right">{stats[i][j + 34]}</td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">Cadre 42/2 par catégorie</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Catégorie</th>
                            {#each seasons as s, i}
                                <th scope="col" class="table-headers">{stats[i][0]}</th>
                            {/each}
                        </tr>
                    </thead>
                    <tbody>
                        {#each statsCadre422Rows as r, j}
                            <tr>
                                <td class="column-left">{r}</td>

                                {#each seasons as s, i}
                                    <td class="column-right">{stats[i][j + 32]}</td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
    </div>
</Accordion>
<br />
<div class="">
    <ButtonGroup>
        {#each seasons as s}
            <Button color="primary" value={s} on:click={(e) => pickSeason(e)}>{s}</Button>
        {/each}
    </ButtonGroup>
    <br /><br />
    <h4>Top {topValue} joueurs en {season}</h4>
</div>

<Accordion>
    <div class={dimens}>
        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">Par # de matchs joués</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Pos</th>
                            <th scope="col" class="table-headers">Joueur</th>
                            <th scope="col" class="table-headers"># Matchs</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each top50NofMatchs as t, i}
                            <tr>
                                <td class="column-center">{i + 1}</td>
                                <td class="column-left">
                                    <button class="border-0 butTable" on:click={() => clickTop(t[0])}>{joueurs[t[0]]}</button>
                                </td>
                                <td class="column-center">{t[1]}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
    </div>
</Accordion>
<br />
<div class={dimens}>
    <label for="customRange2" class="form-label"><strong>Minimum {minMatchsForPct} Matchs</strong></label>
    <input type="range" bind:value={minMatchsForPct} class="form-range" min="10" max="30" id="customRange2" />
</div>
<br />
<Accordion>
    <div class={dimens}>
        <!-- {#key minMatchsForPct} -->

        <AccordionItem class="highlight">
            <h4 class="m-0" slot="header">Par % de victoires (min {minMatchsForPct} matchs)</h4>
            <div class="table-responsive">
                <table class="table table-sm" style="border-collapse: separate;">
                    <thead>
                        <tr>
                            <th scope="col" class="table-headers">Pos</th>
                            <th scope="col" class="table-headers">Joueur</th>
                            <th scope="col" class="table-headers">%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each top50PctWins as t, i}
                            <tr>
                                <td class="column-center">{i + 1}</td>
                                <td class="column-left">
                                    <button class="border-0 butTable" on:click={() => clickTop(t[0])}>{joueurs[t[0]]}</button>
                                </td>
                                <td class="column-center">{parseFloat(t[3] * 100).toFixed(1) + "%"}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </AccordionItem>
        <!-- {/key} -->
    </div>
</Accordion>

<style>
    .butTable {
        background-color: transparent;
        font-weight: bold;
        color: blue;
        text-decoration: underline;
        margin: 0px;
        padding: 0px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .highlight {
        background-color: lightsalmon !important;
        padding: 4px;
        text-align: center;
        font-size: 1.2em;
        font-weight: bold;
        border-radius: 8px;
    }
    .table-headers {
        text-align: center;
        background-color: lightgray;
        border-radius: 4px;
        border: 1px solid gray;
    }
    .column-center {
        text-align: center;
    }
    .column-right {
        text-align: end;
    }
    .column-left {
        text-align: start;
    }
    .center {
        text-align: center;
    }
    .collapsed.accordion-button {
        background-color: red !important;
        border-radius: 8px;
    }
</style>
